// Guard against multiple initializations
let complementaryColorsInitialized = false;

// Function to handle complementary color selection
function handleComplementaryColorSelection(input) {
  const connectedProductUrl = input.getAttribute('data-connected-product-url');
  if (connectedProductUrl) {
    window.location.href = connectedProductUrl;
  }
}

// Single document-level event delegation (capture phase)
function initComplementaryColors() {
  if (complementaryColorsInitialized) return;
  complementaryColorsInitialized = true;

  document.addEventListener('click', function(event) {
    const label = event.target.closest('label.variant-option__button-label--complementary');
    if (!label) return;

    const input = label.querySelector('input[data-complementary-color="true"]');
    if (input) {
      event.preventDefault();
      event.stopPropagation();
      handleComplementaryColorSelection(input);
    }
  }, true);
}

// Initialize once when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initComplementaryColors);
} else {
  initComplementaryColors();
}
